import "./CurriculumVitae.css";

export const CurriculumVitae = () => {
	return (
		<div className='curriculum-vitae-page'>
			<iframe className='curriculum-vitae-iframe' src='CV Daniel Davies.pdf' title='CV' frameBorder={0}></iframe>
		</div>
	);
};
